function getLiftCoreCost(state, props) {
	return state.liftCoreCount === props.targetLiftCoreCount ? 0 : 1e6;
}
export { getLiftCoreCost };

//# sourceMappingURL=index146.js.map